import React from "react"
import PropTypes from "prop-types"

import TextField from "@material-ui/core/TextField"

import InputAdornment from '@material-ui/core/InputAdornment';
export { InputAdornment } from "@material-ui/core/Input"

import classnames from "classnames"
const styleSheet = _theme => ({
  colorInherit: { color: "inherit" },
  inPlaceHelperText: {
    composes: "$colorInherit",
    marginTop: 0,
  },
})

class DecoratedTextField extends React.Component {
  static propTypes = {
    ...TextField.propTypes,

    color: PropTypes.oneOf(["default", "inherit"]),
    inPlace: PropTypes.bool,
    label: PropTypes.node,
    prefix: PropTypes.node,
    suffix: PropTypes.node,
  }

  render() {
    const {
      InputProps: InputPropsProp,
      className: classNameProp,
      classes,
      color,
      inPlace,
      prefix,
      suffix,

      ...otherProps
    } = this.props

    const className = classnames(
      { [classes.colorInherit]: color === "inherit" || inPlace },
      classNameProp
    )

    const InputProps = { ...InputPropsProp }
    if (prefix && !InputProps.startAdornment) {
      InputProps.startAdornment = <InputAdornment position="start">{prefix}</InputAdornment>
    }

    if (suffix && !InputProps.endAdornment) {
      InputProps.endAdornment = <InputAdornment position="end">{suffix}</InputAdornment>
    }

    return <TextField className={className} InputProps={InputProps} {...otherProps} />
  }
}

import withStyles from "@material-ui/core/styles/withStyles"
export default withStyles(styleSheet)(DecoratedTextField)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-DecoratedTextField/DecoratedTextField.js